// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"266e6fd8","703":"1013604a","787":"4d60d14b"}[chunkId] + ".chunk.js";
};